// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___2ITpL","root__message":"style-module__root__message___N2CLK","root__message__text":"style-module__root__message__text___GJ5U2","root__message__text_link":"style-module__root__message__text_link___CP081","root__btn":"style-module__root__btn___Hg_iS"};
    if(module.hot) {
      // 1697460471815
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  